<template>
  <div class="view-account">
    <h1>My Account</h1>

    <br />

    <div class="columns">
      <div class="column">

        <h2>Name</h2>
        <p>{{ contact.customer_name }}</p>

        <br />
        
        <h2>Address</h2>
        <p>
          {{ contact.street }}
          <span v-if="contact.street2">, {{ contact.street2 }}</span>
          <br />
          {{ contact.city }}, {{ contact.state }} {{ contact.zipcode }}
        </p>

        <br />
        
        <h2>Phone</h2>
        <p v-for="phone in contact.phones"
           :key="phone.uuid">
          {{ phone.number }}
        </p>

        <br />
        
        <h2>Email</h2>
        <p v-for="email in contact.emails"
           :key="email.uuid">
          {{ email.address }}
        </p>

        <div v-if="contact.member_active">
          <br />
          <div>
            <h2>Newsletter Preference</h2>
            <p>{{ contact.newsletter_preference_display }}</p>
          </div>
        </div>

      </div> <!-- column -->

      <div class="column">
        <div class="buttons">
          <b-button type="is-primary"
                    tag="router-link" to="/update-info">
            Update Account
          </b-button>
          <b-button type="is-primary"
                    @click="showChangePassword()">
            Change Password
          </b-button>
        </div>
      </div>

    </div> <!-- columns -->

    <b-modal has-modal-card
             :active.sync="showChangePasswordDialog">
      <div class="modal-card">

        <header class="modal-card-head">
          <p class="modal-card-title">Reset Password</p>
        </header>

        <section class="modal-card-body">
          <b-field label="Old Password">
            <b-input v-model="oldPassword" type="password"></b-input>
          </b-field>
          <b-field label="New Password">
            <b-input v-model="newPassword" type="password"></b-input>
          </b-field>
          <b-field label="Confirm Password">
            <b-input v-model="confirmPassword" type="password"></b-input>
          </b-field>
        </section>

        <footer class="modal-card-foot">
          <b-button type="is-primary"
                    @click="submitChangePassword()"
                    :disabled="changePasswordDisabled">
            Change Password
          </b-button>
        </footer>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
    name: 'ViewAccount',
    data() {
        return {
            inited: false,
            contact: {},
            showChangePasswordDialog: false,
            oldPassword: null,
            newPassword: null,
            confirmPassword: null,
        }
    },
    computed: {
        changePasswordDisabled: function() {
            if (!this.oldPassword) {
                return true
            } else if (!this.newPassword) {
                return true
            } else if (this.confirmPassword != this.newPassword) {
                return true
            }
            return false
        },
    },
    created: function() {
        this.init()
    },
    watch: {
        '$store.state.session_established': 'init',
    },
    methods: {

        init() {
            // only need to init once
            if (this.inited) {
                return
            }

            // cannot init until session is established
            if (!this.$store.state.session_established) {
                return
            }

            // go ahead and fetch data if someone is logged in
            if (this.$store.state.user.uuid) {
                this.fetchData()
            } else { // send logged-out users to "login" instead
                this.$router.push('/login')
            }

            // we did it!
            this.inited = true
        },

        fetchData() {
            this.$http.get('/api/my/contact').then(response => {
                this.contact = response.data
            }, response => {
                // TODO: should be smarter than just knee-jerk redirect?
                this.$router.push('/')
            })
        },

        showChangePassword: function() {
            this.oldPassword = null
            this.newPassword = null
            this.confirmPassword = null
            this.showChangePasswordDialog = true
        },

        submitChangePassword: function() {
            let params = {
                'current_password': this.oldPassword,
                'new_password': this.newPassword,
            }

            this.$http.post('/api/change-password', params).then(response => {
                if (response.data.ok) {
                    this.$buefy.toast.open({
                        message: "Your password has been changed.",
                        type: 'is-success',
                    })
                    this.showChangePasswordDialog = false
                } else {
                    this.$buefy.toast.open({
                        message: response.data.error || "something went wrong!",
                        type: 'is-danger',
                    })
                }
            }, response => {
                this.$buefy.toast.open({
                    message: "something went wrong!",
                    type: 'is-danger',
                })
            })
        },
    },
}
</script>
